export default {
    ABERTO: 1,
    FECHADO: 2,

    desc: (value) => {
        switch(value){     
            case 1:
                return 'Em aberto';

            case 2:
                return 'Fechado';

            case 3:
                return 'Cancelado';

        }
    }
}